import { twMerge } from "tailwind-merge";
import TagPriceIcon from "@/assets/icons/tag-price.svg";
import { formatTimeLeft } from "./helpers";
import { SignedSaleOrder, TimedAuctions } from "@/api/orders/types";
import { useCountdownTimer } from "@/shared/hooks/useCountdownTimer";

export interface Props {
  auction?: SignedSaleOrder;
  className?: string;
}

const SaleLabel = ({ auction, className }: Props) => {
  const time = useCountdownTimer(!!auction ? auction.expiresAt : undefined);

  if (!auction || (TimedAuctions.includes(auction.type!) && !time)) return null;

  const label = TimedAuctions.includes(auction.type!)
    ? "Auction ends in"
    : "On sale";

  return (
    <span className={twMerge("inline-block bg-red text-white p-2", className)}>
      <TagPriceIcon className="w-5 h-5 inline fill-white" /> {label}{" "}
      {TimedAuctions.includes(auction.type!) ? (
        <span className="border-l-2 border-white pl-2 ml-2 inline-block">
          {formatTimeLeft(time)}
        </span>
      ) : null}
    </span>
  );
};

export default SaleLabel;
